import { getOutgoingStatisticTooltip } from '../../StatisticsV2/OutgoingStatistics/outgoingStatisticTooltips';

const INCOMING_STATISTIC_TOOLTIPS: Readonly<Record<string, string>> = {
  'common-totalCount':
    'Количество всех имеющихся в базе заданий с учетом выбранных фильтров',
  'common-primaryCount':
    'Количество уникальных номеров телефонов пациентов в рамках заданий по уникальным сценариям',
  'failedReasons-errorCount':
    'Количество заданий со статусом "Обработано" и результатом "Не удалось дозвониться", где звонок завершился со статусом "Ошибка" с учетом выбранных фильтров',
  'failedReasons-hangUpCount':
    'Количество заданий со статусом "Обработано" и результатом "Не удалось дозвониться", где звонок завершился со статусом "Сброс звонка абонентом" с учетом выбранных фильтров',
  'failedReasons-notRecognizedCount':
    'Количество заданий со статусом "Обработано" и результатом "Не удалось дозвониться", где звонок завершился со статусом "Не распознана речь" с учетом выбранных фильтров',
};

export const getIncomingStatisticTooltip = (key: string): string | undefined =>
  INCOMING_STATISTIC_TOOLTIPS[key] ?? getOutgoingStatisticTooltip(key);
